import React, { useMemo } from 'react';
import { ScopePagePair } from 'Types/dealGPT';
import { LlmEnum } from 'Types/llm';

import { ChatMode, MessageFrom } from '../../Types/enums';
import ChatBubble from './ChatBubble';

interface SummaryIntroChatBubbleProps {
  llm: LlmEnum;
  activeTab?: ChatMode;
  totalDocuments: number;
  scopePagePairs: ScopePagePair[];
  collections: string[];
}

const SummaryIntroChatBubble: React.FC<SummaryIntroChatBubbleProps> = ({
  llm,
  activeTab,
  totalDocuments,
  scopePagePairs,
  collections,
}) => {
  const introMessage = useMemo(() => {
    const bullet = (items: string[]) =>
      items.length ? items.map((s) => `• ${s}`).join('\n') : '(None)';

    const groupedScopes = (() => {
      if (!Array.isArray(scopePagePairs)) return [];

      const map: Record<string, string[]> = {};

      scopePagePairs.forEach(({ scope, pageName }) => {
        if (!map[scope]) map[scope] = [];
        map[scope].push(pageName);
      });

      return Object.entries(map).map(([scope, pages]) => `${scope} (${pages.join(', ')})`);
    })();

    const commonFooter = [
      '',
      'Thank you for your patience! Now we can start chatting!\n',
      'What would you like to know more or ask any question about? I would be glad to help you.',
    ].join('\n');

    if (activeTab === ChatMode.DISCOVERY) {
      return [
        `Collections:\n${bullet(collections)}`,
        `\nProcessed: ${totalDocuments} documents`,
        commonFooter,
      ].join('\n');
    }

    if (activeTab === ChatMode.ANALYSIS) {
      return [
        `Scopes:\n${bullet(groupedScopes)}`,
        `\nProcessed: ${totalDocuments} documents`,
        commonFooter,
      ].join('\n');
    }

    return [`Processed: ${totalDocuments} documents`, commonFooter].join('\n');
  }, [activeTab, collections, totalDocuments, scopePagePairs]);

  return (
    <ChatBubble
      llm={llm}
      privateChat={false}
      message={{
        from: MessageFrom.AI,
        message: introMessage,
      }}
    />
  );
};

export default SummaryIntroChatBubble;
